import ins from 'markdown-it-ins';

export default ins;
